export const MeasurementType = {
    Gram: 1,
    Unit: 2,
    GramUnit: 3
};

export const WarehouseType = {
    Storage: 1,
    Sell: 2,
    Damage: 3
};

export const OrderRemoveType = {
    Order: 1,
    Product: 2
};

export const PurchaseOrReturn = {
    Purchase : 1,
    Return : 2
}

export const OrderDiscountType = {
    Percentage: 'Percentage',
    Amount: 'Amount',
    Order: 'Order'
};

export const OrderProductStatus = {
    Open: 1,
    Completed: 2,
    Cancelled: 3,
    Voided: 4,
    ReturnedStoreCredit: 5,
    Reopen: 6,
    ReturnedCash : 7,
    ReturnedCreditCard : 8,
    ReturnedDebitCard : 9,
    ReturnedGiftCard: 12
};

export const CampaignDiscountType = {
    Percentage: 1,
    Amount: 2
};

export const ProductCategoryBulkPriceType = {
    PriceMarginPercentage: 1,
    PricePerUnitAmount: 2,
    PricePerUnitPercentage: 3
};

export const CampaignType = {
    RecurrentSale: 1,
    OneTimeSale: 2
};

export const DayOfWeek = {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6
};

export const RefundReason = {
    Defective: 1,
    Unopened: 2
};

export const BranchName = {
    0: "Broadway",
    1: "Robson" ,
    2: "Online"
};

export const ProductOrderStatus = {
    1: "Open",
    2: "Completed",
    3: "Cancelled",
    4: "Voided",
    5: "ReturnedStoreCredit",
    6: "Reopen" ,
    7: "ReturnedCash",
    8: "ReturnedCreditCard",
    9: "ReturnedDebitCard",
    10: "ReturnedGiftCard"
};

export const OrderStatus = {
    Opened: "Opened",
    Completed: "Completed",
    Cancelled: "Cancelled",
    Returned: "Returned",
    ReturnedPartial: "ReturnedPartial",
    Reopened: "Reopened"
};

export const ApprovalStatus = {
    1: "Cancel",
    2: "Refund",
    3: "Discount",
    4: "Product Discount"
};

export const MixAndMatchSettingType = {
    1: "Bulk Price",
    2: "Discount Percentage",
    3: "Discount Amount"
};

/**
 * Same as TransferProductReason on Object Value (DOMAIN)
 */
export const POReasons = {
    Transfer: "Transfer", /// Regular transfer between warehouses (TechPOS reason)
    Purchased: "Purchased", /// Products purchased via purchase order
    Sale: "Sale", /// Regular sale to retail customers
    ReturnedFromCustomer: "ReturnedFromCustomer", ///  Returned by retail customers to a retail store
    Destroyed: "Destroyed", ///  Destroyed on the premise of a cannabis retail establishment and does not include product sent back to the distributor for destruction
    Addition: "Addition", ///  Any addition to a retail store’s inventory above what they purchased (example: over shipment)
    Lost: "Lost", ///  Any quantity that is subject to criminal theft or is lost
    ReturnedToDistributor: "ReturnedToDistributor", /// Product returned to the distributor by a cannabis retail establishment
    OtherReduction: "OtherReduction" /// A given product which are no longer accounted for by a cannabis retail establishment due to unforeseen reasons
};

export const ScheduleStatus = {
    Active: 1,
    Inactive: 2
};


/**
 * Same as TransferProductReason on Object Value (DOMAIN)
 */
export const TransferProductReason = {
    Transfer: 1, /// Regular transfer between warehouses (TechPOS reason)
    Purchased: 2, /// Products purchased via purchase order
    Sale: 3, /// Regular sale to retail customers
    ReturnedFromCustomer: 4, ///  Returned by retail customers to a retail store
    Destroyed: 5, ///  Destroyed on the premise of a cannabis retail establishment and does not include product sent back to the distributor for destruction
    Addition: 6, ///  Any addition to a retail store’s inventory above what they purchased (example: over shipment)
    Lost: 7, ///  Any quantity that is subject to criminal theft or is lost
    ReturnedToDistributor: 8, /// Product returned to the distributor by a cannabis retail establishment
    OtherReduction: 9 /// A given product which are no longer accounted for by a cannabis retail establishment due to unforeseen reasons
}

export const OnlineOrderStatus = {
    Created: 1,
    Preparing: 2,
    Ready: 3,
    DeliveredPickup: 4,
    Shipped: 5
}

export const TranscationType = {
    
}

export const CardAccountType = {
    0 : "DEFAULT",
    1 : "CHEQUING",
    2 : "SAVINGS",
    4 : "CREDIT"
}

export const CardType = {
    "P " : "Debit",
    "V " : "Visa",
    "M " : "MasterCard",
    "AX" : "American Express"
}

export const LanguageCode = {
    3 : "English",
    4 : "French",
    5 : "French",
    6 : "English"
}

export const PriceByCategoryMode = {
    Normal: 1,
    Aggressive: 2
}

export const Barcode = {
    UPC: 1,
    Product: 2,
    Combo: 3,
    Stacked: 4,
    GreenPreRole: 5
};
